module.exports = __webpack_public_path__ + "static/media/good-vibes.ec14f78b.jpg";